import { Injectable } from "@angular/core";
import { IconConfig } from 'src/app/icons/icon.config';

@Injectable()
export class IconBase {
  // At the moment the icons seems to work perfectly with no overrides.
  constructor(_?: IconConfig) { }
}
